// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"DY-z","sponsoredTooltipWrapper":"EY-z","sponsoredTooltip":"FY-z","newCard":"GY-z"};